module.exports = __webpack_public_path__ + "img/reset_sec_password.44082aac.svg";